var _rect, _line, _line2, _rect2, _rect3, _rect4, _rect5, _g, _rect6, _path, _path2, _rect7, _path3, _path4, _circle, _rect8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPassportPreview = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 539,
    viewBox: "0 0 432 539",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1512_7374)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 2.5,
    width: 423,
    height: 530,
    rx: 3.5,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 267.5,
    x2: 428,
    y2: 267.5,
    stroke: "#EBEDF0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 472.5,
    x2: 428,
    y2: 472.5,
    stroke: "#EBEDF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 268,
    width: 424,
    height: 38,
    fill: "url(#paint0_linear_1512_7374)",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 428,
    y: 268,
    width: 424,
    height: 38,
    transform: "rotate(180 428 268)",
    fill: "url(#paint1_linear_1512_7374)",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 284,
    width: 102.32,
    height: 124,
    fill: "#EBEDF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1512_7374",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 284,
    width: 103,
    height: 124
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 284,
    width: 102.32,
    height: 124,
    fill: "#F2F3F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1512_7374)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.1603,
    cy: 333.694,
    rx: 22.7941,
    ry: 21.2977,
    fill: "#C4C8CC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.6664,
    cy: 406.107,
    rx: 45.5882,
    ry: 42.5954,
    fill: "#C4C8CC"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 424,
    width: 31,
    height: 17.6211,
    rx: 4,
    fill: "#EBEDF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2656 516.422L29.8594 513.031V512.547L37.2656 508.992V509.719L30.7734 512.773L37.2656 515.695V516.422ZM46.4062 516.422L39 513.031V512.547L46.4062 508.992V509.719L39.9141 512.773L46.4062 515.695V516.422ZM55.5469 516.422L48.1406 513.031V512.547L55.5469 508.992V509.719L49.0547 512.773L55.5469 515.695V516.422ZM64.6875 516.422L57.2812 513.031V512.547L64.6875 508.992V509.719L58.1953 512.773L64.6875 515.695V516.422ZM73.8281 516.422L66.4219 513.031V512.547L73.8281 508.992V509.719L67.3359 512.773L73.8281 515.695V516.422ZM82.9688 516.422L75.5625 513.031V512.547L82.9688 508.992V509.719L76.4766 512.773L82.9688 515.695V516.422ZM92.1094 516.422L84.7031 513.031V512.547L92.1094 508.992V509.719L85.6172 512.773L92.1094 515.695V516.422ZM101.25 516.422L93.8438 513.031V512.547L101.25 508.992V509.719L94.7578 512.773L101.25 515.695V516.422ZM110.391 516.422L102.984 513.031V512.547L110.391 508.992V509.719L103.898 512.773L110.391 515.695V516.422ZM119.531 516.422L112.125 513.031V512.547L119.531 508.992V509.719L113.039 512.773L119.531 515.695V516.422ZM128.672 516.422L121.266 513.031V512.547L128.672 508.992V509.719L122.18 512.773L128.672 515.695V516.422ZM137.812 516.422L130.406 513.031V512.547L137.812 508.992V509.719L131.32 512.773L137.812 515.695V516.422ZM146.953 516.422L139.547 513.031V512.547L146.953 508.992V509.719L140.461 512.773L146.953 515.695V516.422ZM156.094 516.422L148.688 513.031V512.547L156.094 508.992V509.719L149.602 512.773L156.094 515.695V516.422ZM165.234 516.422L157.828 513.031V512.547L165.234 508.992V509.719L158.742 512.773L165.234 515.695V516.422ZM174.375 516.422L166.969 513.031V512.547L174.375 508.992V509.719L167.883 512.773L174.375 515.695V516.422ZM183.516 516.422L176.109 513.031V512.547L183.516 508.992V509.719L177.023 512.773L183.516 515.695V516.422ZM192.656 516.422L185.25 513.031V512.547L192.656 508.992V509.719L186.164 512.773L192.656 515.695V516.422ZM201.797 516.422L194.391 513.031V512.547L201.797 508.992V509.719L195.305 512.773L201.797 515.695V516.422ZM210.938 516.422L203.531 513.031V512.547L210.938 508.992V509.719L204.445 512.773L210.938 515.695V516.422ZM220.078 516.422L212.672 513.031V512.547L220.078 508.992V509.719L213.586 512.773L220.078 515.695V516.422ZM229.219 516.422L221.812 513.031V512.547L229.219 508.992V509.719L222.727 512.773L229.219 515.695V516.422ZM238.359 516.422L230.953 513.031V512.547L238.359 508.992V509.719L231.867 512.773L238.359 515.695V516.422ZM247.5 516.422L240.094 513.031V512.547L247.5 508.992V509.719L241.008 512.773L247.5 515.695V516.422ZM256.641 516.422L249.234 513.031V512.547L256.641 508.992V509.719L250.148 512.773L256.641 515.695V516.422ZM265.781 516.422L258.375 513.031V512.547L265.781 508.992V509.719L259.289 512.773L265.781 515.695V516.422ZM274.922 516.422L267.516 513.031V512.547L274.922 508.992V509.719L268.43 512.773L274.922 515.695V516.422ZM284.062 516.422L276.656 513.031V512.547L284.062 508.992V509.719L277.57 512.773L284.062 515.695V516.422ZM293.203 516.422L285.797 513.031V512.547L293.203 508.992V509.719L286.711 512.773L293.203 515.695V516.422ZM302.344 516.422L294.938 513.031V512.547L302.344 508.992V509.719L295.852 512.773L302.344 515.695V516.422ZM311.484 516.422L304.078 513.031V512.547L311.484 508.992V509.719L304.992 512.773L311.484 515.695V516.422ZM320.625 516.422L313.219 513.031V512.547L320.625 508.992V509.719L314.133 512.773L320.625 515.695V516.422ZM329.766 516.422L322.359 513.031V512.547L329.766 508.992V509.719L323.273 512.773L329.766 515.695V516.422ZM338.906 516.422L331.5 513.031V512.547L338.906 508.992V509.719L332.414 512.773L338.906 515.695V516.422ZM348.047 516.422L340.641 513.031V512.547L348.047 508.992V509.719L341.555 512.773L348.047 515.695V516.422ZM357.188 516.422L349.781 513.031V512.547L357.188 508.992V509.719L350.695 512.773L357.188 515.695V516.422ZM366.328 516.422L358.922 513.031V512.547L366.328 508.992V509.719L359.836 512.773L366.328 515.695V516.422ZM375.469 516.422L368.062 513.031V512.547L375.469 508.992V509.719L368.977 512.773L375.469 515.695V516.422ZM384.609 516.422L377.203 513.031V512.547L384.609 508.992V509.719L378.117 512.773L384.609 515.695V516.422ZM393.75 516.422L386.344 513.031V512.547L393.75 508.992V509.719L387.258 512.773L393.75 515.695V516.422ZM402.891 516.422L395.484 513.031V512.547L402.891 508.992V509.719L396.398 512.773L402.891 515.695V516.422ZM412.031 516.422L404.625 513.031V512.547L412.031 508.992V509.719L405.539 512.773L412.031 515.695V516.422Z",
    fill: "#C4C8CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2656 496.422L29.8594 493.031V492.547L37.2656 488.992V489.719L30.7734 492.773L37.2656 495.695V496.422ZM46.4062 496.422L39 493.031V492.547L46.4062 488.992V489.719L39.9141 492.773L46.4062 495.695V496.422ZM55.5469 496.422L48.1406 493.031V492.547L55.5469 488.992V489.719L49.0547 492.773L55.5469 495.695V496.422ZM64.6875 496.422L57.2812 493.031V492.547L64.6875 488.992V489.719L58.1953 492.773L64.6875 495.695V496.422ZM73.8281 496.422L66.4219 493.031V492.547L73.8281 488.992V489.719L67.3359 492.773L73.8281 495.695V496.422ZM82.9688 496.422L75.5625 493.031V492.547L82.9688 488.992V489.719L76.4766 492.773L82.9688 495.695V496.422ZM92.1094 496.422L84.7031 493.031V492.547L92.1094 488.992V489.719L85.6172 492.773L92.1094 495.695V496.422ZM101.25 496.422L93.8438 493.031V492.547L101.25 488.992V489.719L94.7578 492.773L101.25 495.695V496.422ZM110.391 496.422L102.984 493.031V492.547L110.391 488.992V489.719L103.898 492.773L110.391 495.695V496.422ZM119.531 496.422L112.125 493.031V492.547L119.531 488.992V489.719L113.039 492.773L119.531 495.695V496.422ZM128.672 496.422L121.266 493.031V492.547L128.672 488.992V489.719L122.18 492.773L128.672 495.695V496.422ZM137.812 496.422L130.406 493.031V492.547L137.812 488.992V489.719L131.32 492.773L137.812 495.695V496.422ZM146.953 496.422L139.547 493.031V492.547L146.953 488.992V489.719L140.461 492.773L146.953 495.695V496.422ZM156.094 496.422L148.688 493.031V492.547L156.094 488.992V489.719L149.602 492.773L156.094 495.695V496.422ZM165.234 496.422L157.828 493.031V492.547L165.234 488.992V489.719L158.742 492.773L165.234 495.695V496.422ZM174.375 496.422L166.969 493.031V492.547L174.375 488.992V489.719L167.883 492.773L174.375 495.695V496.422ZM183.516 496.422L176.109 493.031V492.547L183.516 488.992V489.719L177.023 492.773L183.516 495.695V496.422ZM192.656 496.422L185.25 493.031V492.547L192.656 488.992V489.719L186.164 492.773L192.656 495.695V496.422ZM201.797 496.422L194.391 493.031V492.547L201.797 488.992V489.719L195.305 492.773L201.797 495.695V496.422ZM210.938 496.422L203.531 493.031V492.547L210.938 488.992V489.719L204.445 492.773L210.938 495.695V496.422ZM220.078 496.422L212.672 493.031V492.547L220.078 488.992V489.719L213.586 492.773L220.078 495.695V496.422ZM229.219 496.422L221.812 493.031V492.547L229.219 488.992V489.719L222.727 492.773L229.219 495.695V496.422ZM238.359 496.422L230.953 493.031V492.547L238.359 488.992V489.719L231.867 492.773L238.359 495.695V496.422ZM247.5 496.422L240.094 493.031V492.547L247.5 488.992V489.719L241.008 492.773L247.5 495.695V496.422ZM256.641 496.422L249.234 493.031V492.547L256.641 488.992V489.719L250.148 492.773L256.641 495.695V496.422ZM265.781 496.422L258.375 493.031V492.547L265.781 488.992V489.719L259.289 492.773L265.781 495.695V496.422ZM274.922 496.422L267.516 493.031V492.547L274.922 488.992V489.719L268.43 492.773L274.922 495.695V496.422ZM284.062 496.422L276.656 493.031V492.547L284.062 488.992V489.719L277.57 492.773L284.062 495.695V496.422ZM293.203 496.422L285.797 493.031V492.547L293.203 488.992V489.719L286.711 492.773L293.203 495.695V496.422ZM302.344 496.422L294.938 493.031V492.547L302.344 488.992V489.719L295.852 492.773L302.344 495.695V496.422ZM311.484 496.422L304.078 493.031V492.547L311.484 488.992V489.719L304.992 492.773L311.484 495.695V496.422ZM320.625 496.422L313.219 493.031V492.547L320.625 488.992V489.719L314.133 492.773L320.625 495.695V496.422ZM329.766 496.422L322.359 493.031V492.547L329.766 488.992V489.719L323.273 492.773L329.766 495.695V496.422ZM338.906 496.422L331.5 493.031V492.547L338.906 488.992V489.719L332.414 492.773L338.906 495.695V496.422ZM348.047 496.422L340.641 493.031V492.547L348.047 488.992V489.719L341.555 492.773L348.047 495.695V496.422ZM357.188 496.422L349.781 493.031V492.547L357.188 488.992V489.719L350.695 492.773L357.188 495.695V496.422ZM366.328 496.422L358.922 493.031V492.547L366.328 488.992V489.719L359.836 492.773L366.328 495.695V496.422ZM375.469 496.422L368.062 493.031V492.547L375.469 488.992V489.719L368.977 492.773L375.469 495.695V496.422ZM384.609 496.422L377.203 493.031V492.547L384.609 488.992V489.719L378.117 492.773L384.609 495.695V496.422ZM393.75 496.422L386.344 493.031V492.547L393.75 488.992V489.719L387.258 492.773L393.75 495.695V496.422ZM402.891 496.422L395.484 493.031V492.547L402.891 488.992V489.719L396.398 492.773L402.891 495.695V496.422ZM412.031 496.422L404.625 493.031V492.547L412.031 488.992V489.719L405.539 492.773L412.031 495.695V496.422Z",
    fill: "#C4C8CC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 424,
    width: 31,
    height: 18.6,
    rx: 4,
    fill: "#EBEDF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 428C100 425.791 101.791 424 104 424H127C129.209 424 131 425.791 131 428V432.525H100V428Z",
    fill: "#C4C8CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100 434.075H131V438.6C131 440.809 129.209 442.6 127 442.6H104C101.791 442.6 100 440.809 100 438.6V434.075Z",
    fill: "#C4C8CC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.5,
    cy: 433.3,
    r: 3.65,
    fill: "#C4C8CC",
    stroke: "#EBEDF0",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 2.5,
    width: 423,
    height: 530,
    rx: 3.5,
    stroke: "#EBEDF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1512_7374",
    x: 0,
    y: 0,
    width: 432,
    height: 539,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1512_7374"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1512_7374",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1512_7374",
    x1: 216,
    y1: 268,
    x2: 216,
    y2: 306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1512_7374",
    x1: 640,
    y1: 268,
    x2: 640,
    y2: 306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPassportPreview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/passport-preview.4eee6f0e22ed2fc3b0c607cce1be108a.svg";